export default __webpack_public_path__ + "static/media/logo.e2e2b4f1.svg";